import { render, staticRenderFns } from "./AddReason.vue?vue&type=template&id=779aa14c&scoped=true&"
import script from "./AddReason.vue?vue&type=script&lang=js&"
export * from "./AddReason.vue?vue&type=script&lang=js&"
import style0 from "./AddReason.vue?vue&type=style&index=0&id=779aa14c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779aa14c",
  null
  
)

export default component.exports